import { PdfGen } from '../pdf/pdf';
import { OptsImageSingle } from './optsImageSingle';

export const ILayoutImageSingleSymbol = Symbol('LayoutImageSingle');

export interface ILayoutImageSingleGen {
  generate(pdf: PdfGen, opts: OptsImageSingle): Promise<void>;
}
